import { AppBar, Box, Button, Card, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fade, Grid, IconButton, InputAdornment, InputBase, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Theme, ThemeProvider, Tooltip, Typography, createStyles, makeStyles } from '@material-ui/core';
import { Add, ArrowBack, Delete, Search } from '@material-ui/icons';
import { Pagination } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Page from '../../containers/Page/Page';
import { api } from '../../services/api';
import { ContextualTheme } from '../../themes';
import { Helpers } from '../../utils/Helpers';

interface IModelo {
    id: string;
    nome: string;
}

interface IModeloData {
    data: IModelo[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

interface ISegmento {
    id: string;
    segmento: string;
}

interface IDesconto {
    desc_j: string;
    desc_classe: string;
    desc_1110: string;
    desc_prog: string;
    fatdesc: string;
}

interface IData {
    id: string;
    cliente_id: string;
    cliente_nome: string;
    modelo_id: string;
    modelo_nome: string;
    segmento_id: string;
    segmento_nome: string;
    desc_1110: string;
    desc_classe: string;
    desc_j: string;
    desc_prog: string;
    fatdesc: string;
}

interface IParams {
    id: string;
    cliente: string;
}

function DescontosCreate() {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams<IParams>();

    const { enqueueSnackbar: alert } = useSnackbar();

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [modelos, setModelos] = React.useState<IModelo[]>([]);
    const [modelosDialog, setModelosDialog] = React.useState<boolean>(false);
    const [modelosLoading, setModelosLoading] = React.useState<boolean>(false);
    const [modelosSearch, setModelosSearch] = React.useState<string>('');
    const [modelosData, setModelosData] = React.useState<IModeloData>();
    const [segmentos, setSegmentos] = React.useState<ISegmento[]>([]);
    const [segmentosData, setSegmentosData] = React.useState<ISegmento[]>([]);
    const [segmentosDialog, setSegmentosDialog] = React.useState<boolean>(false);
    const [descontos, setDescontos] = React.useState<IDesconto>({} as IDesconto);
    const [saveLoading, setSaveLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<IData[]>([]);
    const [deleteLoading, setDeleteLoading] = React.useState<string>('');
    const [cliente, setCliente] = React.useState<string>('');

    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchModelos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchSegmentos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function handleFetch(load = true) {
        setLoading(load);
        try {
            const response = await api.get(`descontos/${params.cliente}`);
            setData(response.data.object);
            setCliente(response.data.cliente);
            setError('');
        } catch (error: any) {
            setError(error.response.data.message);
        }
        setLoading(false);
    }

    async function handleFetchSegmentos() {
        try {
            const response = await api.get('propostas/create');
            setSegmentosData(response.data.object.segmentos);
        } catch (error) {
            Helpers.error(error, alert);
        }
    }

    async function handleFetchModelos(page: number = 1) {
        setModelosLoading(true);
        try {
            const response = await api.get(`modelos?search=${modelosSearch}&page=${page}&ativa=1`);
            setModelosData(response.data.object);
        } catch (error) {
            Helpers.error(error, alert);
        }
        setModelosLoading(false);
    }

    async function handleDelete(row: IData) {
        if (!deleteLoading) {
            setDeleteLoading(row.id);
            try {
                const response = await api.delete(`descontos/${row.id}`);
                let newData = data.filter(i => i.id !== row.id);
                setData(newData);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            }
            setDeleteLoading('');
        }
    }

    async function handleSave() {
        setSaveLoading(true);
        try {
            const response = await api.post(`descontos/${params.cliente}`, {
                modelos_id: modelos,
                segmentos_id: segmentos,
                ...descontos,
                fatdesc: getFatDesc()
            });
            await handleFetch(false);
            alert(response.data.message, { variant: 'success' });
            resetForm();
        } catch (error) {
            Helpers.error(error, alert);
        }
        setSaveLoading(false);
    }

    function handleModelosKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetchModelos();
        }
    }

    function resetForm() {
        setSegmentos([]);
        setModelos([]);
        setDescontos({} as IDesconto);
    }

    function getSegmentosName() {
        if (segmentos.length > 0) {
            if (segmentos.length > 1) {
                return segmentos.length + ' SEGMENTOS';
            } else {
                return segmentos[0].segmento;
            }
        } else {
            return '';
        }
    }

    function getModelosName() {
        if (modelos.length > 0) {
            if (modelos.length > 1) {
                return modelos.length + ' MODELOS';
            } else {
                return modelos[0].nome;
            }
        } else {
            return '';
        }
    }

    function selectSegmento(segmento: ISegmento) {
        let newSegmentos = [];
        if (segmentos.some(e => e.id === segmento.id)) {
            newSegmentos = segmentos.filter(b => b.id !== segmento.id);
        } else {
            newSegmentos = segmentos.filter(b => b.id !== segmento.id);
            newSegmentos = [...segmentos, segmento];
        }
        setSegmentos(newSegmentos);
    }

    function selectModelo(bomba: IModelo) {
        let newModelos = [];
        if (modelos.some(e => e.id === bomba.id)) {
            newModelos = modelos.filter(b => b.id !== bomba.id);
        } else {
            newModelos = modelos.filter(b => b.id !== bomba.id);
            newModelos = [...modelos, bomba];
        }
        setModelos(newModelos);
    }

    function getFatDesc() {
        return (getFat(descontos.desc_classe)
            * getFat(descontos.desc_1110)
            * getFat(descontos.desc_prog)).toFixed(4);
    }

    function getFat(value: string) {
        return ((100 - getValue(value)) / 100);
    }

    function getValue(value: string) {
        let newValue = +value || 0;
        return newValue;
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <IconButton size="small" color="primary" className={classes.backButton} onClick={() => history.goBack()}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" component="div">
                        {`Cliente: ${cliente}`}
                    </Typography>
                </Box>
            </Page.Title>
            <Page.Section>
                <Page.Content>
                    <Box p={2}>
                        <Grid className={classes.row} container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="segmentos_id"
                                    name="segmentos_id"
                                    label="Segmentos"
                                    variant="outlined"
                                    disabled={true}
                                    fullWidth={true}
                                    value={getSegmentosName()}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Selecionar">
                                                    <IconButton color="primary" edge="end" onClick={() => setSegmentosDialog(true)}>
                                                        <Search />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Dialog open={segmentosDialog} fullWidth={true} maxWidth="xs">
                                <DialogTitle>Selecionar Segmentos</DialogTitle>
                                <DialogContent>
                                    <List>
                                        {segmentosData.map((segmento, index) => (
                                            <ListItem button key={index} onClick={() => selectSegmento(segmento)}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={segmentos.some(e => e.id === segmento.id)}
                                                        tabIndex={-1}
                                                        disableRipple={true}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={segmento.segmento}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </DialogContent>
                                <DialogActions>
                                    <Button color="primary" onClick={() => setSegmentosDialog(false)}>
                                        Fechar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="modelos_id"
                                    name="modelos_id"
                                    label="Modelos"
                                    variant="outlined"
                                    disabled={true}
                                    fullWidth={true}
                                    value={getModelosName()}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Selecionar">
                                                    <IconButton color="primary" edge="end" onClick={() => setModelosDialog(true)}>
                                                        <Search />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Dialog open={modelosDialog} fullWidth={true} maxWidth="xs">
                                <AppBar style={{ position: 'relative' }}>
                                    <DialogTitle>Selecionar Modelos</DialogTitle>
                                    <Box mx={3} mb={3}>
                                        <Paper className={classes.custom}>
                                            <InputBase
                                                autoFocus
                                                disabled={loading}
                                                className={classes.input}
                                                placeholder="Pesquisa"
                                                onChange={(event) => setModelosSearch(event.target.value)}
                                                onKeyUp={(event) => handleModelosKeyUp(event)}
                                                value={modelosSearch}
                                            />
                                            <IconButton
                                                disabled={loading}
                                                style={{ padding: 10 }}
                                                onClick={() => handleFetchModelos()}
                                            >
                                                <Search />
                                            </IconButton>
                                        </Paper>
                                        <Box mt={2}>
                                            <Grid container justifyContent="center">
                                                <Pagination
                                                    page={modelosData?.current_page || 1}
                                                    count={modelosData?.last_page || 1}
                                                    onChange={(_event, page) => handleFetchModelos(page)}
                                                    color="secondary"
                                                />
                                            </Grid>
                                        </Box>
                                    </Box>
                                    <Fade in={modelosLoading} timeout={500}>
                                        <LinearProgress color="secondary"></LinearProgress>
                                    </Fade>
                                </AppBar>
                                <DialogContent>
                                    <List>
                                        {modelosData && modelosData.data ? modelosData.data.map((modelo, index) => (
                                            <ListItem button key={index} onClick={() => selectModelo(modelo)}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={modelos.some(e => e.id === modelo.id)}
                                                        tabIndex={-1}
                                                        disableRipple={true}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={modelo.nome}
                                                />
                                            </ListItem>
                                        )) : modelos.map((modelo, index) => (
                                            <ListItem button key={index} onClick={() => selectModelo(modelo)}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={modelos.some(e => e.id === modelo.id)}
                                                        tabIndex={-1}
                                                        disableRipple={true}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={modelo.nome}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </DialogContent>
                                <DialogActions>
                                    <Button color="primary" onClick={() => setModelosDialog(false)}>
                                        Fechar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="desc_j"
                                    name="desc_j"
                                    label="Desconto Conjunto"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    value={descontos.desc_j || ''}
                                    onChange={(event) => setDescontos({ ...descontos, desc_j: event.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="desc_classe"
                                    name="desc_classe"
                                    label="Desconto Classe"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    value={descontos.desc_classe || ''}
                                    onChange={(event) => setDescontos({ ...descontos, desc_classe: event.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="desc_1110"
                                    name="desc_1110"
                                    label="Desconto 1110"
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    value={descontos.desc_1110 || ''}
                                    onChange={(event) => setDescontos({ ...descontos, desc_1110: event.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="desc_prog"
                                    name="desc_prog"
                                    label="Desconto Prog."
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    value={descontos.desc_prog || ''}
                                    onChange={(event) => setDescontos({ ...descontos, desc_prog: event.target.value })}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="fatdesc"
                                    name="fatdesc"
                                    label="Fat. Desc."
                                    variant="outlined"
                                    type="number"
                                    fullWidth={true}
                                    disabled={true}
                                    value={getFatDesc()}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Button
                                    style={{ height: '100%' }}
                                    color="secondary"
                                    variant="contained"
                                    size="medium"
                                    startIcon={saveLoading ? <CircularProgress color="inherit" size={16} /> : <Add />}
                                    fullWidth={true}
                                    disabled={saveLoading}
                                    onClick={() => handleSave()}>
                                    Adicionar
                                </Button>
                            </Grid>
                        </Grid>
                        {data &&
                            <Card variant="outlined">
                                <TableContainer>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Segmento</TableCell>
                                                <TableCell>Modelo</TableCell>
                                                <TableCell>Desconto Conjunto</TableCell>
                                                <TableCell>Desconto Classe</TableCell>
                                                <TableCell>Desconto 1110</TableCell>
                                                <TableCell>Desconto Prog.</TableCell>
                                                <TableCell>Fat. Desc.</TableCell>
                                                <TableCell align="center">Excluir</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map((row) => (
                                                <TableRow
                                                    key={row.id}
                                                    hover={true}
                                                >
                                                    <TableCell>{row.segmento_nome}</TableCell>
                                                    <TableCell>{row.modelo_nome}</TableCell>
                                                    <TableCell>{row.desc_j}</TableCell>
                                                    <TableCell>{row.desc_classe}</TableCell>
                                                    <TableCell>{row.desc_1110}</TableCell>
                                                    <TableCell>{row.desc_prog}</TableCell>
                                                    <TableCell>{Number.parseFloat(row.fatdesc).toFixed(4)}</TableCell>
                                                    <TableCell align="center">
                                                        <ThemeProvider theme={ContextualTheme}>
                                                            {deleteLoading === row.id ?
                                                                <CircularProgress color="secondary" size={16} />
                                                                :
                                                                <IconButton size="small" color="secondary" onClick={() => handleDelete(row)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            }
                                                        </ThemeProvider>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        }
                    </Box>
                </Page.Content>
            </Page.Section>
        </Page>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginRight: theme.spacing(1),
        },
        row: {
            marginBottom: theme.spacing(1)
        },
        custom: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
        },
    })
);

export default DescontosCreate;